// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"accordion_contentContainer__Kd3Hl","expanded":"accordion_expanded__BvHAd"};